export const base_url = "https://nftbase.ai/"

// export const base_url = "http://localhost:3000/"
